import { CompanyView } from "./CompanyView";
import { CompanyCreate } from "./CompanyCreate";
import { CompanyEdit } from "./CompanyEdit";
import { CompaniesList } from "./CompaniesList";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";

export default {
  icon: BusinessOutlinedIcon,
  list: CompaniesList,
  create: CompanyCreate,
  edit: CompanyEdit,
  show: CompanyView,
};
